import { createStyles, makeStyles } from '@material-ui/styles';
import differenceInBusinessDays from 'date-fns/differenceInBusinessDays';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

export const useStyles = makeStyles(() =>
    createStyles({
        dateChip: {
            backgroundColor: '#F2F2F2',
            padding: '4px 12px 4px 12px',
            borderRadius: '44px',
            marginBottom: '5px',
            fontFamily: 'Poppins',
            fontSize: '12px',
            fontWeight: 400,
            textAlign: 'center',
            textTransform: 'uppercase',
        },
    }),
);

const DATE_DISPLAY_FORMAT = 'dd MMM yyyy';

export default function ChatDate(props) {
    const { messages, index } = props;
    const classes = useStyles();
    let diff: number | null = null;
    let currentMessageDate: Date = new Date();
    try {
        currentMessageDate = parseISO(messages[index]?.created);
        const previousMessageDate = messages[index - 1]?.created ? parseISO(messages[index - 1]?.created) : new Date();
        diff = differenceInBusinessDays(currentMessageDate, previousMessageDate);
    } catch (e) {
        console.error(e);
    }
    if (!diff) return null;
    return (
        <div className="d-flex justify-content-center">
            <div className={classes.dateChip}>{format(currentMessageDate, DATE_DISPLAY_FORMAT)}</div>
        </div>
    );
}
